import { ArrowUpRight, BriefcaseBusiness } from "lucide-react";
import type { CareerCardData } from "../lib/types";
import { FitScoreBadge } from "./FitScoreBadge";

export function CareerCard({ career }: { career: CareerCardData }) {
  return (
    <article className="group rounded-[2rem] border border-moss/10 bg-white p-6 shadow-soft transition hover:-translate-y-1 md:p-8">
      <div className="flex items-start justify-between gap-4">
        <div>
          <span className="mb-5 inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.18em] text-moss/60">
            <BriefcaseBusiness size={15} /> Direction {String(career.rank).padStart(2, "0")}
          </span>
          <h3 className="font-display text-3xl leading-tight text-ink">{career.title}</h3>
        </div>
        <FitScoreBadge score={career.fitScore} />
      </div>
      <p className="mt-5 leading-7 text-ink/70">{career.whyItFits}</p>
      {career.risks?.[0] && <p className="mt-4 rounded-2xl bg-cream px-4 py-3 text-sm text-ink/65"><b>Test first:</b> {career.risks[0]}</p>}
      {career.entryRoles && career.entryRoles.length > 0 && (
        <div className="mt-5 flex flex-wrap gap-2">
          {career.entryRoles.map((role) => <span className="rounded-full border border-moss/15 px-3 py-1 text-xs font-semibold text-moss" key={role}>{role}</span>)}
        </div>
      )}
      <ArrowUpRight className="mt-6 text-coral transition group-hover:translate-x-1 group-hover:-translate-y-1" />
    </article>
  );
}
